
export default function Policy() {

    return(

        <div className="container policy__container">

            <h1>Privacy Policy</h1>
            
                
        </div> 

    )

}